const CODE = 'NewPasswordRequired';

export class NewPasswordRequiredError extends Error {

  constructor() {
    super(CODE);
    this['error'] = { code: CODE };
  }
}
